/**
 * GPR national shipping (Spec 2, T3.9): Pickup and Ship line properties are exclusive by
 * the selected variant. Loaded by snippets/ship-date-property.liquid on products with a
 * `Fulfillment` option only, independent of enable_national_shipping, so a flag-off
 * rollback keeps line properties right.
 */
import { ThemeEvents } from '@theme/events';

/** @param {{ options?: string[] } | null} variant */
function sideOfVariant(variant) {
  // Case-insensitive: 'Ship to Me' and 'Ship to me' are the same side.
  const options = (variant?.options || []).map((o) => String(o).trim().toLowerCase());
  if (options.includes('ship to me')) return 'ship';
  if (options.includes('pickup at the ranch')) return 'pickup';
  return '';
}

if (!window.__gprLineProperties) {
  window.__gprLineProperties = true;

  document.addEventListener(ThemeEvents.variantUpdate, (event) => {
    const detail = /** @type {CustomEvent} */ (event).detail;
    if (!detail?.resource || !(event.target instanceof Element)) return;
    const side = sideOfVariant(detail.resource);
    if (!side) return;
    const scope = event.target.closest('.shopify-section, dialog') || document;
    const productId = String(detail.data?.newProduct?.id || detail.data?.productId || '');
    if (!productId) return;
    scope.querySelectorAll(`product-form-component[data-product-id="${productId}"] input[data-gpr-side]`).forEach((input) => {
      if (input instanceof HTMLInputElement) input.disabled = input.dataset.gprSide !== side;
    });
  });
}
